import React, { useEffect, useState } from "react";
import { MdExpandLess, MdExpandMore  } from "react-icons/md";
import { formatNumber } from "../../utils/helper";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getCurrency, mapDuration } from "../../utils/helper";
import SkeletonLine from "../Common/SkeletonLine";

const options = ["Current", "1 Month", "3 Months", "6 Months", "1 Year", "All"];

const RanksPrices = ({ data, loading, salesData, settingsData }) => {
  const [isOpen, setIsOpen] = useState(true);
  const total_days = useSelector((state) => state.globalStates.total_days);
 const [selectedOption, setSelectedOption] = useState(() =>
  options.includes(settingsData?.defaultValues?.ranksprices_timeframe)
    ? settingsData.defaultValues.ranksprices_timeframe
    : "1 Month"
);
  const [estimatedTime, setEstimatedTime] = useState(1);
  const dispatch = useDispatch();

  const FBA_prices = data?.FBA_prices;
  const FBM_prices = data?.FBM_prices;
  const amazon_prices = {
    ...data?.amazon_prices,
    current: data?.current?.amazon,
  };
  const bb_drops = data?.bb_prices;
  const keepa_drops = {
    
    last_30_days: data?.keepa_bsr_drops_30,
    last_90_days: data?.keepa_bsr_drops_90,
    last_180_days: data?.keepa_bsr_drops_180,
    all: data?.keepa_bsr_drops_365,
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
      if(settingsData?.defaultValues?.ranksprices_timeframe){
        const defaultOption = options.includes(settingsData.defaultValues.ranksprices_timeframe)
          ? settingsData.defaultValues.ranksprices_timeframe
          : selectedOption;
        setSelectedOption(defaultOption);
      }
    }, [settingsData])

  useEffect(() => {
    if (selectedOption === "Current" || selectedOption === "1 Month") {
      setEstimatedTime(1);
    } else if (selectedOption === "3 Months") {
      setEstimatedTime(3);
    } else if (selectedOption === "6 Months") {
      setEstimatedTime(6);
    } else if (selectedOption === "1 Year") {
      setEstimatedTime(12);
    } else if (selectedOption === "All") {
      setEstimatedTime(12);
    }
  }, [selectedOption]);

  const keepaMapping = {
    "Current": "last_30_days",
    "1 Month": "last_30_days",
    "3 Months": "last_90_days",
    "6 Months": "last_180_days",
    "1 Year": "last_365_days",
    'All': 'all'
  };

  const formatValue = (value, prefix = "") => {
    if (value === "-" || value === "--" || isNaN(value)) {
      return "-";
    }
    return `${prefix}${value}`;
  };
  

  const properties = [
    {
      title: "🇺🇸 BSR (TOP%)",
      // value: (data?.current?.bsr && data?.current?.bsr !== -1) ? data?.current?.bsr : '-',
      value:
        selectedOption === "Current" && data?.current?.bsr !== -1
          ? formatNumber(data?.current?.bsr)
          : selectedOption === "1 Month" &&
            data?.bsr_ranks?.value_30_days !== -1
          ? formatNumber(data?.bsr_ranks?.value_30_days)
          : selectedOption === "3 Months" &&
            data?.bsr_ranks?.value_90_days !== -1
          ? formatNumber(data?.bsr_ranks?.value_90_days)
          : selectedOption === "6 Months" &&
            data?.bsr_ranks?.value_180_days !== -1
          ? formatNumber(data?.bsr_ranks?.value_180_days)
          : selectedOption === "1 Year" &&
            data?.bsr_ranks?.value_365_days !== -1
          ? formatNumber(data?.bsr_ranks?.value_365_days)
          : selectedOption === "All" && data?.bsr_ranks?.value_all_days !== -1
          ? formatNumber(data?.bsr_ranks?.value_all_days)
          : "-",
    },
    {
      title: "Buy Box",
      // value: data?.current?.buyBoxPrice !== -1
      //     ? formatValue(data?.current?.buyBoxPrice / 100, '$')
      //     : '-',
      value:
        selectedOption === "Current" && data?.current?.buyBoxPrice !== -1
          ? formatValue(
              parseFloat(data?.current?.buyBoxPrice / 100).toFixed(2),
              getCurrency(settingsData?.marketplace)
            )
          : selectedOption === "1 Month" && data?.bb_prices?.data_30?.avg !== -1
          ? formatValue(
              parseFloat(data?.bb_prices?.data_30?.avg / 100).toFixed(2),
              getCurrency(settingsData?.marketplace)
            )
          : selectedOption === "3 Months" && data?.bb_prices?.data_90?.avg !== -1
          ? formatValue(
              parseFloat(data?.bb_prices?.data_90?.avg / 100).toFixed(2),
              getCurrency(settingsData?.marketplace)
            )
          : selectedOption === "6 Months" &&
            data?.bb_prices?.data_180?.avg !== -1
          ? formatValue(
              parseFloat(data?.bb_prices?.data_180?.avg / 100).toFixed(2),
              getCurrency(settingsData?.marketplace)
            )
          : selectedOption === "1 Year" &&
            data?.bb_prices?.data_365?.avg !== -1
          ? formatValue(
              parseFloat(data?.bb_prices?.data_365?.avg / 100).toFixed(2),
              getCurrency(settingsData?.marketplace)
            )
          : selectedOption === "All" && data?.current?.buyBoxPrice !== -1
          ? formatValue(
              parseFloat(data?.bb_prices?.data_all?.avg / 100).toFixed(2),
              getCurrency(settingsData?.marketplace)
            )
          : "-",
    },
    {
      title: "Amazon",
      // value: data?.current?.amazon !== -1
      //     ? formatValue(data?.current?.amazon / 100, '$')
      //     : '-',
      value:
        selectedOption === "Current" && data?.current?.amazon !== -1
          ? formatValue(parseFloat(data?.current?.amazon / 100).toFixed(2), getCurrency(settingsData?.marketplace))
          : selectedOption === "1 Month" &&
            data?.amazon_prices?.data_30?.avg !== -1
          ? formatValue(
              parseFloat(data?.amazon_prices?.data_30?.avg / 100).toFixed(2),
              getCurrency(settingsData?.marketplace)
            )
          : selectedOption === "3 Months" &&
            data?.amazon_prices?.data_90?.avg !== -1
          ? formatValue(
              parseFloat(data?.amazon_prices?.data_90?.avg / 100).toFixed(2),
              getCurrency(settingsData?.marketplace)
            )
          : selectedOption === "6 Months" &&
            data?.amazon_prices?.data_180?.avg !== -1
          ? formatValue(
              parseFloat(data?.amazon_prices?.data_180?.avg / 100).toFixed(2),
              getCurrency(settingsData?.marketplace)
            )
          : selectedOption === "1 Year" &&
            data?.amazon_prices?.data_365?.avg !== -1
          ? formatValue(
              parseFloat(data?.amazon_prices?.data_365?.avg / 100).toFixed(2),
              getCurrency(settingsData?.marketplace)
            )
          : selectedOption === "All" && data?.current?.amazon !== -1
          ? formatValue(parseFloat(data?.amazon_prices?.data_all?.avg / 100).toFixed(2), getCurrency(settingsData?.marketplace))
          : "-",
    },
    {
      title: "Lowest FBA",
      value:
        FBA_prices &&
        ((selectedOption === "Current" && data?.current?.min_fba !== -1) ||
          (selectedOption === "1 Month" && FBA_prices?.min_30 !== -1) ||
          (selectedOption === "3 Months" && FBA_prices?.min_90 !== -1) ||
          (selectedOption === "6 Months" && FBA_prices?.min_180 !== -1) ||
          (selectedOption === "1 Year" && FBA_prices?.min_365 !== -1) ||
          (selectedOption === "All" && FBA_prices?.min_all !== -1))
          ? formatValue(
              (selectedOption === "Current" &&
                parseFloat(data?.current?.min_fba).toFixed(2)) ||
                (selectedOption === "1 Month" &&
                  parseFloat(FBA_prices?.min_30 / 100).toFixed(2)) ||
                (selectedOption === "3 Months" &&
                  parseFloat(FBA_prices?.min_90 / 100).toFixed(2)) ||
                (selectedOption === "6 Months" &&
                  parseFloat(FBA_prices?.min_180 / 100).toFixed(2)) ||
                  (selectedOption === "1 Year" &&
                    parseFloat(FBA_prices?.min_365 / 100).toFixed(2)) ||
                (selectedOption === "All" &&
                  parseFloat(FBA_prices?.min_all / 100).toFixed(2)),
              getCurrency(settingsData?.marketplace)
            )
          : "-",
    },
    {
      title: "Lowest FBM",
      value:
        FBM_prices &&
        ((selectedOption === "Current" && data?.current?.min_fbm !== -1) ||
          (selectedOption === "1 Month" && FBM_prices?.min_30 !== -1) ||
          (selectedOption === "3 Months" && FBM_prices?.min_90 !== -1) ||
          (selectedOption === "6 Months" && FBM_prices?.min_180 !== -1) ||
          (selectedOption === "1 Year" && FBM_prices?.min_365 !== -1) ||
          (selectedOption === "All" && FBM_prices?.min_all !== -1))
          ? formatValue(
              (selectedOption === "Current" &&
                parseFloat(data?.current?.min_fbm).toFixed(2)) ||
                (selectedOption === "1 Month" &&
                  parseFloat(FBM_prices?.min_30 / 100).toFixed(2)) ||
                (selectedOption === "3 Months" &&
                  parseFloat(FBM_prices?.min_90 / 100).toFixed(2)) ||
                (selectedOption === "6 Months" &&
                  parseFloat(FBM_prices?.min_180 / 100).toFixed(2)) ||
                  (selectedOption === "1 Year" &&
                    parseFloat(FBM_prices?.min_365 / 100).toFixed(2)) ||
                (selectedOption === "All" &&
                  parseFloat(FBM_prices?.min_all / 100).toFixed(2)),
              getCurrency(settingsData?.marketplace)
            )
          : "-",
    },
    {
      title: "Keepa BSR Drops",
      value:
        keepa_drops?.[keepaMapping[selectedOption]] !== undefined
          ? keepa_drops[keepaMapping[selectedOption]] +
            (selectedOption === "Current" ? " last 30 days" : "")
          : "-",
      isKeepaDrops: true,
    },
    {
      title: "NET BB Price Changes",
      value: formatValue(
        (selectedOption === "Current" && bb_drops?.bb_drops_30) ||
          (selectedOption === "1 Month" && bb_drops?.bb_drops_30) ||
          (selectedOption === "3 Months" && bb_drops?.bb_drops_90) ||
          (selectedOption === "6 Months" && bb_drops?.bb_drops_180) ||
          (selectedOption === "1 Year" && bb_drops?.bb_drops_365) ||
          (selectedOption === "All" && bb_drops?.bb_drops_all) ||
          "-"
      ),
      // value: bb_drops && (selectedOption === 'Current' && bb_drops?.bb_drops_30 !== -1 ||
      //     selectedOption === '30' && bb_drops?.bb_drops_30 !== -1 ||
      //     selectedOption === '90' && bb_drops?.bb_drops_90 !== -1 ||
      //     selectedOption === '180' && bb_drops?.bb_drops_180 !== -1 ||
      //     selectedOption === 'All' && bb_drops?.bb_drops_180 !== -1)
      //     ? formatValue(
      //         (selectedOption === 'Current' && bb_drops?.bb_drops_30) ||
      //         (selectedOption === '30' && bb_drops?.bb_drops_30) ||
      //         (selectedOption === '90' && bb_drops?.bb_drops_90) ||
      //         (selectedOption === '180' && bb_drops?.bb_drops_180) ||
      //         (selectedOption === 'All' && bb_drops?.bb_drops_180),
      //         '$'
      //     )
      //     : '-',
    },
    {
      title: "Estimated Sales/ Mo",
      value:
        salesData?.sales_estimation?.monthly_sales &&
        salesData?.sales_estimation?.monthly_sales !== -1
          ? formatNumber(salesData?.sales_estimation?.monthly_sales)
          : "-",
      // value: Number(salesData?.sales_estimation?.monthly_sales) !== -1
      //     ? formatNumber(salesData?.sales_estimation?.monthly_sales)
      //     : '-',
    },
  ];

  const handleClick = (value) => {
    if (!value.includes(getCurrency(settingsData?.marketplace))) return;
    const price = value.replace(/\$/g, "");
    dispatch({
      type: "SET_PRICES",
      payload: {
        sale_price: price,
      },
    });
  }

  return (
    <div>
        <div
          className="flex cursor-pointer items-center mb-2 justify-between"
          onClick={toggleAccordion}
        >
          <div
            className="mr-1 text-primary font-bold"
            style={{
              fontSize: "16px",
            }}
          >
            Ranks & Prices
          </div>
          <div className="text-primary">
            {isOpen ? <MdExpandMore className="w-6 h-6" /> : <MdExpandLess className="w-6 h-6" />}
          </div>
        </div>
        {isOpen && (
          <>
            <div className="flex items-center bg-secondary-bg rounded-md mb-2">
              {options.map((option, index) => (
                <div
                  key={index}
                  className={`cursor-pointer w-full px-3 py-2 text-center text-sm font-semibold rounded-md ${
                    selectedOption === option
                      ? "bg-primary text-secondary"
                      : "text-primary"
                  }`}
                  onClick={() => setSelectedOption(option)}
                >
                  {mapDuration(option)}
                </div>
              ))}
            </div>
            <div className="bg-secondary-bg p-4 rounded-xl flex flex-col gap-2">
              {properties.map((property, index) => (
                <div
                  key={index}
                  className={`flex justify-between text-md`}
                >
                  <div className="my-auto text-[#a8a8a8]">{property.title}</div>
                  <div
                    className={`cursor-pointer ${
                      property.isKeepaDrops
                        ? "border border-red-500 bg-red-500/20 rounded-md px-2 py-0.5 text-red-500"
                        : "text-primary"
                    }`}
                    onClick={()=>handleClick(property.value)}
                  >
                    {loading ? <SkeletonLine /> : property.value}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
    </div>
  );
};

export default RanksPrices;
